export default {
  data () {
    return {
      uniqueId: Date.now()
    }
  },
  methods: {
    generateDynamicName (baseName) {
      return `${baseName}-${this.uniqueId}-${Math.random().toString(36).substr(2, 9)}`
    }
  }
}
